import React from "react";
import { Fab } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
const Back = () => {
  const navigate = useNavigate();
  return (
    <>
      <Fab
        color="primary"
        size="medium"
        sx={{
          bottom: { xs: 16, sm: 24 },
          left: { xs: 16, md: 264 },
          position: "fixed",
          zIndex: (theme) => theme.zIndex.appBar - 1,
        }}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceIcon />
      </Fab>
    </>
  );
};

export default Back;
